<section
  class="relative flex h-auto flex-col gap-x-4 overflow-hidden pl-4 pt-4 md:h-[calc(100vh-104px)] md:flex-row"
>
  <app-billing-list
    class="w-full md:flex-1"
    [payments]="payments$ | async"
    [isPaymentsLoading]="isPaymentsLoading$ | async"
    [isPaymentsLoaded]="isPaymentsLoaded$ | async"
    [invoices]="invoices$ | async"
    [isInvoicesLoading]="isInvoicesLoading$ | async"
    [isInvoicesLoaded]="isInvoicesLoaded$ | async"
    [selectedInvoice]="selectedInvoice$ | async"
    [invoiceSelectedFilter]="selectedInvoiceFilter$ | async"
    [paymentSelectedFilter]="selectedPaymentFilter$ | async"
    (selectInvoice)="onSelectInvoice($event)"
    (downloadInvoice)="downloadFile($event)"
    (changeInvoiceFilterSelection)="changeInvoiceFilterSelection($event)"
    (changePaymentFilterSelection)="changePaymentFilterSelection($event)"
  ></app-billing-list>

  @if ((browserSize$ | async) !== 'small') {
    <app-billing-detail
      class="w-full md:flex-1"
      [isInvoicesLoading]="isInvoicesLoading$ | async"
      [selectedInvoice]="selectedInvoice$ | async"
      (downloadInvoice)="downloadFile($event)"
    ></app-billing-detail>
  }
</section>
